import IntlMessage from "components/util-components/IntlMessage";
import AppLocale from "lang";

const setLocale = (isLocaleOn, localeKey) => isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
export default setLocale

const setLocaleJS = (langInRoute, localeKey) => {
    const appLocale = AppLocale[langInRoute];
    if (!appLocale) {
    }
    return (appLocale || AppLocale["en"]).messages[localeKey];
  };
  
  export { setLocaleJS };